import { render, staticRenderFns } from "./ApiHistories.vue?vue&type=template&id=345a10ae&scoped=true"
import script from "./ApiHistories.vue?vue&type=script&lang=js"
export * from "./ApiHistories.vue?vue&type=script&lang=js"
import style0 from "./ApiHistories.vue?vue&type=style&index=0&id=345a10ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345a10ae",
  null
  
)

export default component.exports